import { Typography } from "@circle-react-uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

import { getCompareTableGridColsClass } from "../../utils/compareTableGridCols";
import { usePlans } from "../PlansContext";

interface SectionWrapperProps {
  children: ReactNode;
  sectionName: ReactNode;
}

export const SectionWrapper = ({
  sectionName,
  children,
}: SectionWrapperProps) => {
  const { compareTablePlanFeatures } = usePlans();

  if (!compareTablePlanFeatures) return null;

  const tiers = Object.keys(compareTablePlanFeatures);

  const labelProps = { weight: "medium" };

  const cols = getCompareTableGridColsClass(tiers.length + 1);
  const headerClasses = classNames("grid", cols, "bg-primary");

  return (
    <div className="bg-primary mb-12">
      <div className={headerClasses}>
        <div className="mb-2">
          <Typography.LabelMd {...labelProps}>{sectionName}</Typography.LabelMd>
        </div>
      </div>
      <div className={classNames("grid", cols)}>{children}</div>
    </div>
  );
};
